import { config } from '../../../config';
import { CountryCode } from '../../hocs/withInitialData';
import { Language } from '../../providers/TranslatedTheme';

export interface CommunicationCultureLanguage {
  code: Language;
  default: boolean;
  label: string;
}

export interface CommunicationCultureCountry {
  nativeName: string;
  language: CommunicationCultureLanguage[];
  name: string;
  code: CountryCode;
}

export default class CountryRepository {
  async fetchAll(
    tenant = config.tenant
  ): Promise<CommunicationCultureCountry[]> {
    const commonHeaders = {
      'Content-Type': 'application/json',
    };

    const response = await fetch(
      `${config.api.baseUrl}/v1/${tenant}/countries`,
      {
        method: 'get',
        headers: commonHeaders,
      }
    );

    const responseData: { data: CommunicationCultureCountry[] } =
      await response.json();
    return responseData.data;
  }
}
